import * as React from "react";
import pollinatorIcon from "./pollinator-icon.svg";
const SVG = require("react-inlinesvg").default;
const Icon = require("@atlaskit/icon").default;

const svg = <SVG src={pollinatorIcon} />;

export const PollinatorIcon = <Icon label="Pollinator" glyph={() => svg} />;
